let newsContent = [
    {id: 1, imgUrl: "/images/Main/Main-news-1.jpg", date: "01 Jan, 2015", title: "Typesetting industry", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",},
    {id: 2, imgUrl: "/images/Main/Main-news-2.jpg", date: "01 Jan, 2015", title: "Typesetting industry", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",},
    {id: 3, imgUrl: "/images/Main/Main-news-3.jpg", date: "01 Jan, 2015", title: "Typesetting industry", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",},
]

export default newsContent